import React from 'react';
import Radio from 'antd/lib/radio';

const RadioGroup = Radio.Group;

const RadioSort = ({ label, list, onChange, allLabel, filterId, value}) => {

  return (
    <div className="row">
      <div className="col-md-3 col-lg-2">
        {label}
      </div>
      <div className="col-md-9 col-lg-10">
        <RadioGroup onChange={(e) => {
          onChange(e.target.value);
        }} value={value}>
          <Radio key={`${filterId}Opts_-1`} value={-1} checked>{allLabel}</Radio>
          {list.map((item,index) => <Radio key={`${filterId}Opts_${index}`} value={index}>{item}</Radio>)}
        </RadioGroup>
      </div> 
    </div>
  );
}

export default RadioSort